/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';

import { MegaMenuListLink } from '../MegaMenuStyles';
import { LazyLink } from '../../../../../../../../slices/atoms';

const navigationTracking = (name, category) => {
  window.analytics.track('Web Interaction', {
    action: 'click',
    category,
    name,
  });
};

const ListLinks = data =>
  // Mapping through the Community Mega Menu data
  data.map(item => (
    <MegaMenuListLink
      url={item.get_involved_link && item.get_involved_link.url}
      key={item.get_involved_text}
      renderAs={LazyLink}
      onClick={() => {
        navigationTracking(item.get_involved_tracking_name, item.get_involved_tracking_category);
      }}
    >
      {item.get_involved_text}
    </MegaMenuListLink>
  ));

export default ListLinks;

ListLinks.propTypes = {
  data: PropTypes.node.isRequired,
};
